<template>
    <DefaultHeader />

    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-12">
                <div class="card shadow my-2 p-1 bg-white rounded">
                    <div class="row d-flex justify-content-around align-items-center">

                        <div class="col col-md-6">
                            <BadgeCard :badge="badgeInfo" />
                        </div>

                        <div class="col col-md-4">
                            <form>
                                <h5 class="text-center my-3">Filtrer par date : </h5>
                                    <div class="row d-flex justify-content-center">
                                        <div class="input-group my-1">
                                            <span class="input-group-text bg-secondary-subtle">Début : </span>
                                            <input class="form-control" type="date" v-model="startDate" required>
                                        </div>
                                    </div>
                                    <div class="row d-flex justify-content-center">
                                        <div class="input-group my-1">
                                            <span class="input-group-text bg-secondary-subtle">Fin : </span>
                                            <input class="form-control" type="date" v-model="endDate" required>
                                        </div>
                                    </div>
                                    <div class="row d-flex justify-content-center my-1">
                                        <ButtonDisplay class="col-2" :type="'search'" @click="getBadgeAlarms(); this.currentPage = 1; onPageChange(this.currentPage)"/>
                                    </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-12 d-flex flex-column justify-content-between">
                <div class="card shadow mt-2 my-md-0 p-3 bg-white rounded">
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Adresse</th>
                                    <th scope="col">Véhicule</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(alarm, index) in alarms" :key="index">
                                    <td>
                                        <AlarmName :alarm="alarm" />
                                    </td>
                                    <td v-if="alarm && alarm.date">{{ alarm.date }}</td>
                                    <td v-else>N.C.</td>
                                    <td v-if="alarm && alarm.address">{{ alarm.address }}</td>
                                    <td v-else>N.C.</td>
                                    <td v-if="alarm && alarm.balise">
                                        <VehicleNameDisplay :balise="alarm.balise" />
                                    </td>
                                    <td v-else>N.C.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-center my-2">
                        <div class="row col-12 col-md-6">
                            <div class="d-flex justify-content-start">
                                <div class="col-8"><label for="resPerPage">Résultats par page :</label></div>
                                <div class="col-3"><select name="resPerPage" id="resPerPage" class="form-select"
                                        v-model="this.perPage"
                                        @change="setPerPage($event); this.currentPage = 1; onPageChange(this.currentPage)">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </select></div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import FormatHelper from '@/helpers/format.helper.js'
import AlarmService from '@/services/alarm.service'
import Pagination from '@/components/PaginationComponent.vue'
import BadgeCard from '@/components/display/BadgeCard.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import BadgeService from '@/services/badge.service'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        Pagination,
        BadgeCard,
        VehicleNameDisplay,
        ButtonDisplay
    },
    data() {
        return {
            badgeInfo: null,
            alarms: null,
            alarmsCount: null,
            pages: null,
            currentPage: 1,
            startResults: 0,
            perPage: 15,
            isEnd: false,
            displayEnd: false,
            startDate: null,
            endDate: null,
            enDateWithHours: null,
            totalPages: 0
        }
    },
    mounted() {
        this.getBadgeInfos()
    },
    methods: {
        getBadgeInfos() {
            BadgeService.getBadge(this.$route.params.id)
                .then(response => {
                    this.badgeInfo = FormatHelper.badgeInfoFormat(response.data);
                    this.getBadgeAlarms()
                })
                .catch(e => {
                    console.log(e);
                });
        },
        getBadgeAlarms() {
            this.alarms = []
            if (this.endDate) {
                this.enDateWithHours = this.endDate + 'T23:59:59'
            }
            AlarmService.getBadgeAlarms(this.badgeInfo.number, this.startResults, this.perPage, this.startDate, this.endDateWithHours)
                .then(response => {
                    this.alarms = FormatHelper.baliseAlertsFormat(response.data.rows)
                    this.alarmsCount = response.data.count
                    this.totalPages = Math.ceil(this.alarmsCount / this.perPage)
                })
        },
        onPageChange(page) {
            if (page > 1) {
                this.startResults = (page - 1) * this.perPage
            }
            else {
                this.startResults = 0
            }
            this.alarms = []
            AlarmService.getBadgeAlarms(this.badgeInfo.number, this.startResults, this.perPage, this.startDate, this.endDateWithHours)
                .then(response => {
                    this.alarms = FormatHelper.baliseAlertsFormat(response.data.rows)
                })
            this.totalPages = Math.ceil(this.alarmsCount / this.perPage)
            this.currentPage = page
        },
        setPerPage(event) {
            this.perPage = event.target.value
            this.totalPages = Math.ceil(this.alarmsCount / this.perPage)
        },
        getDuration(startDate, endDate) {

            console.log(typeof startDate)
            console.log(typeof endDate)
            //const timeDifference = new Date(startDate).getTime() - new Date(endDate).getTime();
            //const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24))

            return startDate;
        }
    }
}
</script>